import request from './request'
import handleError from './handle-error'
import isMobile from './is-mobile'
import { HOST, TB_URL } from './config'
import { getToken, setToken, removeToken } from './token'
import beforeRouteLeave from './before-route-leave'
import toast from './toast'
import { getUserId, setUserId, removeUserId } from './user-id'
import { getLang, setLang, removeLang } from './languages'
import formDate from './form-date'

export {
  request,
  handleError,
  isMobile,
  HOST,
  TB_URL,
  getToken,
  setToken,
  removeToken,
  beforeRouteLeave,
  toast,
  getUserId,
  setUserId,
  removeUserId,
  getLang,
  setLang,
  removeLang,
  formDate,
}



// WEBPACK FOOTER //
// ./src/utils/index.js